import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "login-page" }

import { reactive } from 'vue'
import { iRequestLogin } from '@/types/requests'
import useFormRequest from '@/composables/useFormRequest'
import { login } from '@/api/auth'
import store from '@/store'
import FormItem from '@/components/common/FormItem.vue'
import { loadRegions } from '@/api/regions'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const form = reactive<iRequestLogin>({
  username: '',
  password: ''
})

const request = useFormRequest<iRequestLogin>()

const handleSubmit = () => {
  request.tryRequest(async () => {
    const response = await login(form)
    store.login(response.data)

    store.setCurrentRegion(undefined)

    const regionsResponse = await loadRegions()
    store.setRegions(regionsResponse.data)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_custom_input = _resolveComponent("custom-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Вход", -1)),
    _withDirectives((_openBlock(), _createElementBlock("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _createVNode(FormItem, {
        error: _unref(request).state.errors.username
      }, {
        default: _withCtx(() => [
          _createVNode(_component_custom_input, {
            modelValue: form.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.username) = $event)),
            label: "Имя пользователя"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["error"]),
      _createVNode(FormItem, {
        error: _unref(request).state.errors.password
      }, {
        default: _withCtx(() => [
          _createVNode(_component_custom_input, {
            modelValue: form.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
            type: "password",
            label: "Пароль"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["error"]),
      _cache[2] || (_cache[2] = _createElementVNode("button", {
        class: "button",
        type: "submit"
      }, "Войти", -1))
    ], 32)), [
      [_directive_loading, _unref(request).state.pending]
    ])
  ]))
}
}

})